import React from "react";
import { ShiftCardView } from "./view";
import { styles } from "./styles";

export const ShiftCard = props => <ShiftCardView {...props} styles={styles} />;
